"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleParser = void 0;
var RuleSet_1 = require("./RuleSet");
var EarleyParser_1 = require("./EarleyParser");
// --------------------------------------------------------------------------
// The ruleparser uses the parser to parse your rules from a string
// into a RuleSet. It extends the grammar to handle *, +, ?, and | operators
// in the grammar.
// --------------------------------------------------------------------------
var RuleParser = /** @class */ (function () {
    /**
     * @constructor
     */
    function RuleParser(dbg) {
        var _this = this;
        // a unique number to let us make up rule names.
        this.nextRuleId = 0;
        // The buildset is the rules that we are building.
        this.buildSet = new RuleSet_1.RuleSet();
        // The rules are the grammar of the rules themselves.
        var rules = new RuleSet_1.RuleSet();
        // Lets us access this from local functions inside this function.
        // var self = this;
        rules.addRule('start', ['rule']);
        rules.addRule('identifier', ["'[A-Za-z0-9_]+'"]);
        rules.addRule('terminal', ["''([^'\\\\]|\\\\.)*''"]);
        rules.addRule('expr', ['or_expr']);
        rules.addRule('rule', ['identifier', "':'", 'expr'], function (args) {
            _this.buildSet.addRule(args[0], args[2], _this.action);
            return args[0];
        });
        rules.addRule('rule', ['identifier', "':'"], function (args) {
            _this.buildSet.addRule(args[0], [], _this.action);
            return args[0];
        });
        rules.addRule('or_expr', ['or_expr', "'\\|'", 'cat_expr'], function (args) {
            // Implement the or operator by making two new rules.
            var name = '_' + _this.nextRuleId++;
            _this.buildSet.addRule(name, args[0]);
            _this.buildSet.addRule(name, args[2]);
            return [name];
        });
        rules.addRule('or_expr', ['cat_expr']);
        rules.addRule('cat_expr', ['cat_expr', 'list_expr'], function (args) {
            args[0].push(args[1]);
            return args[0];
        });
        rules.addRule('cat_expr', ['list_expr'], function (args) { return [args[0]]; });
        rules.addRule('list_expr', ['kleene_expr']);
        rules.addRule('list_expr', ["'\\['", 'kleene_expr', "','", 'kleene_expr', "'\\]'"], function (args) {
            var nameOpt = '_' + _this.nextRuleId++;
            var name = '_' + _this.nextRuleId++;
            _this.buildSet.addRule(nameOpt, [name]);
            _this.buildSet.addRule(nameOpt, [], function (_args) { return []; });
            _this.buildSet.addRule(name, [args[1]], function (args) { return args; }); // list of one element.)
            _this.buildSet.addRule(name, [name, args[3], args[1]], function (args) {
                // join the lists and return the result.
                args[0].push(args[2]);
                return args[0];
            });
            return nameOpt;
        });
        rules.addRule('kleene_expr', ['basic_expr', "'[\\+\\*\\?]'"], function (args) {
            var name = '_' + _this.nextRuleId++;
            // Simulates kleene-star operations by adding more rules.
            if (args[1] == '*') {
                _this.buildSet.addRule(name, [name, args[0]], function (args) {
                    args[0].push(args[1]);
                    return args[0];
                });
                _this.buildSet.addRule(name, [], function (_args) { return []; });
            }
            else if (args[1] == '?') {
                _this.buildSet.addRule(name, [args[0]]);
                _this.buildSet.addRule(name, [], function (args) { return null; });
            }
            else if (args[1] == '+') {
                var name2 = '_' + _this.nextRuleId++;
                _this.buildSet.addRule(name, [name2, args[0]]);
                _this.buildSet.addRule(name2, [name2, args[0]]);
                _this.buildSet.addRule(name2, []);
            }
            return name;
        });
        rules.addRule('kleene_expr', ['basic_expr']);
        rules.addRule('basic_expr', ['identifier']);
        rules.addRule('basic_expr', ["'\\('", 'expr', "'\\)'"], function (args) {
            var name = '_' + _this.nextRuleId++;
            _this.buildSet.addRule(name, args[1]);
            return name;
        });
        rules.addRule('basic_expr', ['terminal']);
        rules.finalize();
        //dbg.printf("%s", rules);
        this.parser = new EarleyParser_1.EarleyParser(rules, dbg);
    }
    // ----------------------------------------------------------------------
    // Add a token to the rules. See RuleSet.addToken().
    // ----------------------------------------------------------------------
    RuleParser.prototype.addToken = function (name, re) {
        this.buildSet.addToken(name, re);
    };
    // ----------------------------------------------------------------------
    // Add a rule to the grammar. The rule will be parsed and can include
    // regular-expression-like syntax.
    // ----------------------------------------------------------------------
    RuleParser.prototype.addRule = function (str, action) {
        this.action = action;
        this.parser.parse(str);
    };
    return RuleParser;
}());
exports.RuleParser = RuleParser;
//# sourceMappingURL=RuleParser.js.map